<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  [(showPopup)]="chartPopupVisible"
  (closePopup)="hideChartPopup()"
  [beginningStateReferrer]="beginningStateReferrer"
  closeFeature="COMPS_PAGE"
></app-chart-popup>
<div class="comps-page-container">
  <ng-container *ngIf="tabId !== ''; else emptyCompBlock">
    <div class="comps-ops-holder" *ngIf="metaReady">
      <div class="comps-name-holder" #check>
        <div class="input-with-action" *ngIf="inEditMode; else displayName">
          <input
            #compsRename
            nz-input
            nzSize="small"
            placeholder="Enter Peer Analysis Table Name"
            [title]="compsName"
            [(ngModel)]="compsName"
            maxlength="100"
            [class.in-edit-mode]="inEditMode"
          />
          <div
            class="save-edit-holder comps-toggle-icon-onhover"
            [class.in-edit-mode]="inEditMode"
            (click)="toggleEditMode(compsName)"
          >
            <va-icon
              size="small"
              [name]="inEditMode ? 'save' : 'edit'"
              class="comps-edit-icon"
            ></va-icon>
            <va-icon
              size="small"
              [name]="inEditMode ? 'save' : 'edit'"
              class="comps-edit-icon"
            ></va-icon>
          </div>
        </div>
        <ng-template #displayName>
          <div class="input-with-action">
            <div
              class="display-name"
              (click)="setEditMode()"
              [title]="compsName"
            >
              {{ compsName }}
            </div>
            <div
              class="save-edit-holder comps-toggle-icon-onhover"
              style="border-bottom: 1px solid #36abad"
              [class.in-edit-mode]="inEditMode"
              (click)="toggleEditMode(compsName)"
            >
              <va-icon
                size="small"
                [name]="inEditMode ? 'save' : 'edit'"
                class="comps-edit-icon"
              ></va-icon>
              <va-icon
                size="small"
                [name]="inEditMode ? 'save' : 'edit'"
                class="comps-edit-icon"
              ></va-icon>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="comps-ops">
        <button
          class="va-button va-button-outline va-button-outline--primary mr-12"
          [ngClass]="[
            isConvertToTimeSeriesModalVisible ? 'va-button--active' : '',
            !leftModalDataReady || !updateMetaReady ? 'va-button--disabled' : ''
          ]"
          *ngIf="compType !== 'TimeSeries'"
          (click)="convertToTimeSeries(tplTitle)"
          tile="Switch to Trend View"
        >
          Switch to Trend View
        </button>
        <ng-template #tplTitle>
          <span class="modal-title">Switch to Trend View</span
          ><span class="modal-instruction">
            - Please select {{ MAX_LINES_TIMESERIES }} line items and date range
            to see the trend view</span
          >
        </ng-template>
        <app-global-user-settings-button
          [disabled]="!metaReady"
          class="mr-12"
        ></app-global-user-settings-button>
        <button
          title="Share"
          class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
          (click)="shareTable()"
          *ngIf="tabType === 'user_comp'"
          [ngClass]="[
            !updateMetaReady ? 'va-button--disabled' : '',
            isShareTableModalVisible ? 'va-button--active' : ''
          ]"
        >
          <va-icon
            [isFontAwesome]="true"
            [name]="faShare"
            class="va-button-icon"
          ></va-icon>
        </button>
        <button
          class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
          *ngIf="tabType !== 'user_comp'"
          (click)="saveComps(false)"
          [ngClass]="[!updateMetaReady ? 'va-button--disabled' : '']"
          title="Save to Custom Tables"
        >
          <va-icon size="small" name="save" class="va-button-icon"></va-icon>
        </button>
        <button
          class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
          [ngClass]="[
            exportOptVisible ? 'va-button--active' : '',
            !updateMetaReady ? 'va-button--disabled' : ''
          ]"
          nz-popover
          nzPopoverTrigger="click"
          [nzPopoverContent]="exportOptionsTemplate"
          [nzPopoverPlacement]="
            currentTabType === 'user_tabs' ? 'bottom' : 'bottomRight'
          "
          [(nzPopoverVisible)]="exportOptVisible"
          [nzPopoverOverlayClassName]="'comps-export-popover'"
          title="Export"
        >
          <va-icon
            *ngIf="!loadingDocuments; else exportLoading"
            size="small"
            name="file-excel"
            class="va-button-icon"
          ></va-icon>
        </button>
        <!-- Export options template -->
        <ng-template #exportOptionsTemplate>
          <div (click)="exportValue(1)" class="export-opt">Values</div>
          <div class="export-opt" (click)="exportValue(0)">
            Excel Add-In Formulas
          </div>
        </ng-template>
        <!-- Export loading template -->
        <ng-template #exportLoading>
          <div>
            <ng-template #indicatorTemplate>
              <va-icon
                [isFontAwesome]="true"
                [name]="faSpinner"
                [spin]="true"
                class="va-button-icon"
              ></va-icon>
            </ng-template>
            <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
          </div>
        </ng-template>

        <button
          (click)="deleteTab(selectedTab, $event)"
          class="va-button va-icon-button va-button-outline va-button-outline--danger"
          title="Click to delete Peer Analysis Table"
          *ngIf="currentTabType === 'user_tabs'"
          [ngClass]="[
            showDeleteModal ? 'va-button--active' : '',
            !updateMetaReady ? 'va-button--disabled' : ''
          ]"
        >
          <va-icon size="small" name="trash" class="va-button-icon"></va-icon>
        </button>
      </div>
    </div>
    <div class="grid-filters" *ngIf="metaReady">
      <div
        nz-col
        [nzSpan]="compType === 'TimeSeries' ? 23 : 20"
        class="filter-col"
      >
        <div class="on-screen-filter-wrapper">
          <div class="onscr-ticker mr-24">
            <label class="filter-label">Tickers</label>
            <app-ticker-search
              [tickers]="rowTickers"
              [onScreen]="true"
              [isComp]="true"
              (onSearchedTickerUpdate)="onSearchTickerSelection($event)"
              [hasSearchIcon]="true"
              [disabled]="
                !(tickerModalDataReady && metaReady && !tickerDeletionInProcess)
              "
              [suggestedTickers]="peerCompanies"
              placeholder="&nbsp;Add Tickers"
              [maxSelectedTickerCount]="MAX_TICKERS"
            ></app-ticker-search>
            <button
              nz-button
              class="on-screen-search__edit-btn"
              (click)="editTickers()"
              [disabled]="
                !(tickerModalDataReady && metaReady && !tickerDeletionInProcess)
              "
            >
              Edit
            </button>
          </div>
          <div class="onscr-ticker mr-24">
            <app-lineitem-filter
              [options]="stdLineItems"
              [selectedValue]="{}"
              [selectedOptionsId]="selectedLiId"
              liFilterId="chartsPageLI"
              [bottomBorderView]="true"
              [disabled]="!(leftModalDataReady && metaReady)"
              label="Line Items"
              [showButton]="true"
              (onValueChange)="onSearchedLi($event)"
              (onEditButtonClick)="editLineItems()"
            ></app-lineitem-filter>
          </div>
        </div>
        <app-comps-grid-filters
          (saveCurrency)="UpdateCurrency($event)"
          [sources]="allSources"
          (setPeriod)="setSelectedPeriod($event)"
          (saveSource)="updateSource($event)"
          (saveDataview)="updateDataview($event)"
          (saveYearType)="updateYearType($event)"
          [currency]="currency"
          [othercurrencies]="othercurrencies"
          [source]="source"
          [filterData]="filterData"
          [compType]="compType"
          [currentTabType]="currentTabType"
          [metaReady]="metaReady"
          [updateMetaReady]="updateMetaReady"
          [leftModalDataReady]="leftModalDataReady"
          [periodsWithAvailableData]="periodsWithAvailableData"
        ></app-comps-grid-filters>
      </div>
    </div>
    <div class="comps-grid-holder" *ngIf="metaReady">
      <div *ngIf="compType === 'TimeSeries'">
        <div
          *ngFor="let tableSli of sliIds; let i = index"
          [ngStyle]="{
            'padding-bottom': i === sliIds.length - 1 ? '0px' : '25px'
          }"
        >
          <app-comps-grid
            [metaReady]="metaReady"
            [dataReady]="dataReady"
            [isTimeSeries]="true"
            [fuzzySwitch]="fuzzySwitch"
            [compsTableData]="timeSeriesTableData[tableSli]"
            [hasUnsavedData]="hasUnsavedData"
            [hasContextMenu]="true"
            [hasFormulaBar]="true"
            (onShowChart)="showChartPopup($event)"
            (onDeleteTicker)="onDeleteTicker($event)"
          >
          </app-comps-grid>
        </div>
      </div>
      <div *ngIf="compType !== 'TimeSeries'">
        <app-comps-grid
          [metaReady]="metaReady"
          [dataReady]="dataReady"
          [compsTableData]="compsTableData"
          [isTimeSeries]="false"
          [fuzzySwitch]="fuzzySwitch"
          [hasContextMenu]="true"
          [hasFormulaBar]="true"
          (onShowChart)="showChartPopup($event)"
          (onDeleteTicker)="onDeleteTicker($event)"
        >
        </app-comps-grid>
      </div>
    </div>
    <div *ngIf="!metaReady" style="height: 100%; background-color: white">
      <ul nz-menu>
        <li
          *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
          style="padding: 0px 15px 0px 15px"
        >
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </li>
      </ul>
    </div>

    <div
      class="display-flexbox jc-space-between"
      [ngStyle]="{ visibility: dataReady ? 'visible' : 'hidden' }"
      *ngIf="metaReady"
    >
      <div class="fuzzy-panel">
        <span style="font-size: 16px">~</span>&nbsp;&nbsp;<span
          style="font-style: italic; color: grey"
        >
          Best Match Data</span
        >
        and Actual Data
        <a (click)="showFuzzyModal = true">More Info</a>&nbsp;&nbsp;
        <span style="color: lightgray"
          >Highlight Best Matches:
          <span style="cursor: pointer" (click)="toggleFuzzySwitch()">
            <va-icon
              [isFontAwesome]="true"
              [name]="fuzzySwitch ? faToggleOn : faToggleOff"
              style="color: #ec7b1e"
            ></va-icon>
          </span>
        </span>
      </div>
      <div class="text-align-right">
        <span style="font-size: 12px; color: rgba(0, 0, 0, 0.65)">{{
          compType === "TimeSeries"
            ? timeSeriesTableData[sliIds[0]].extras.magnitudeMessage
            : compsTableData.extras.magnitudeMessage
        }}</span>
        <div *ngIf="factsetDataAccess" class="factset_copyright_footnote">
          {{ factsetCopyRightMessage }}
        </div>
      </div>
    </div>

    <nz-modal
      [(nzVisible)]="showFuzzyModal"
      nzTitle="Best Match Logic"
      nzWidth="500px"
      [nzFooter]="null"
      (nzOnCancel)="showFuzzyModal = false"
    >
      <ng-container *nzModalContent>
        <div class="textSection">
          <p>
            Visible Alpha uses Best Match to indicate where we have identified
            line items investors want to compare but where the peers report
            differently.
          </p>
          <p>
            For example, Bloomin' Brands (BLMN) does not report systemwide same
            store sales (SSS), so we use domestic same stores sales growth as a
            proxy, while Brinkers International (EAT) does provide systemwide
            SSS. By presenting these in a single SSS line item, we take out much
            of the effort in constructing deep estimate Peer Analysis tables.
          </p>
          <p>
            To see the original line item being used in best match, refer to the
            audit formula bar. Best match sources are highlighted in orange
            within the bar.
          </p>
        </div>
      </ng-container>
    </nz-modal>
  </ng-container>
  <ng-template #emptyCompBlock>
    <div class="empty-comp-template">
      <p>You have not created any custom Peer Analysis Tables.</p>
      <p>
        Click
        <button
          nz-button
          (click)="createNewComp()"
          [ngClass]="tickerModalDataReady ? 'create-btn' : ''"
          style="margin-right: 0px"
          [disabled]="!tickerModalDataReady"
        >
          Create Peer Analysis Table
        </button>
        to create your first one, or view pre-built tables on the left panel.
      </p>
    </div>
  </ng-template>
</div>

<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon name="check" class="snack-icon snack-success-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon name="close-circle" class="snack-icon snack-failure-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon name="info-circle" class="snack-icon snack-info-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
